<template>
  <div id="SeatingMap">
    <b-container>
      <div class="title">Seating Map</div>
      <Map />
    </b-container>
    <b-container class="chart-container">
      <Chart />
      <p>
        *If you are on a multi-year agreement your price may differ from those
        shown in the map and pricing grid above.
      </p>
    </b-container>
  </div>
</template>

<script>
import Map from "./Map";
import Chart from "./Chart";

export default {
  name: "SeatingMap",
  components: {
    Map,
    Chart,
  },
};
</script>

<style lang="scss" scoped>
#SeatingMap {
  background-image: url("~images/seating/seating-map-bg.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  padding: 88px 0 127.54px 0;
  @media (min-width: 992px) {
    background-attachment: fixed;
  }
  @media (max-width: 992px) {
    padding: 54px 0 78px 0;
  }
  .container {
    display: flex;
    flex-direction: column;
    &.chart-container {
      @media (max-width: 480px) {
        padding-right: 0;
        margin-right: 0;
      }
    }
    .title {
      position: relative;
      font-family: Birdrockers;
      font-weight: normal;
      font-size: 52px;
      line-height: 52px;
      letter-spacing: normal;
      color: #ffffff;
      margin: 0 auto 75px auto;
      @media (max-width: 992px) {
        font-size: 42px;
        line-height: 42px;
      }
    }
    p {
      font-family: DINPro;
      font-weight: normal;
      font-size: 18px;
      line-height: 28px;
      letter-spacing: normal;
      color: #ffffff;
      margin-top: 25px;
      text-align: center;
      @media (max-width: 992px) {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
}
</style>